const COLOR_MODES = {
  ORANGE: 'orange',
  BRAND: 'BRAND',
};

const ACCOUNT_ACCESS = {
  RESTRICTED: 'Restricted',
  FULL_ACCESS: 'Full Access',
};

export {
  COLOR_MODES,
  ACCOUNT_ACCESS,
};



// WEBPACK FOOTER //
// ./app/app-constants.js